import Component from '../abstracts/Component';
import Cookies from 'js-cookie';

export default class LoginPopupComponent extends Component {

  get SELECTORS() {
    return {
      textCloseBtn: "[data-text-close]",
      loginTogglerButton: "#loginTogglerButton",
      textContainer: "[data-text-container]",
      loginPopup: "[data-login-popup]",
      accountIconLoginPopup: "[data-myaccount-login-popup]",
      loginPopupSpeechBubbleCta: "[data-login-speechbubble-cta]",
      loginPopupBackdrop: "[data-login-popup-backdrop]",
      popupCloseBtn: "[data-popup-close]",
      recoveryPasswordContainer: '[data-password-recovery]',
      pwdRecoveryBtn: '[data-pwd-recovery-btn]',
      loginForm: '[data-login-form]',
      showLoginBtn: '[data-show-login-btn]',
      recoveryPasswordForm: '#recoveryPwdForm',
      recoveryPasswordFormButton: '#recoveryPwdForm .custom-button',
      recoveryPasswordFormInput: '#recoveryPwdForm input[type="email"]',
      responseSuccess: '[data-mail-sent="true"]',
      responseSuccessWrapper: '[data-success-wrapper]',
      recoveryPasswordFormWrapper: '[data-form-wrapper]',
      responseFail: '[data-mail-sent="false"] .form-input',
      recoveryPasswordInput: 'input[type="email"]',
      recoveryPasswordBtn: 'button[type="submit"]'
    };
  }

  get CLASSES() {
    return {
      hidden: 'hidden',
      loading: 'loading'
    }
  }

  get COOKIE_NAME() {
    return {
      popupTextClose: 'login_popup_text_close',
      popupLoginClose: 'login_popup_close',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.counter = 0;
    this.timerId = null;
    this.timeoutId = null;
    this.loginPopupActive = document.body.getAttribute("data-login-popup-active");
  }


  readDOM() {
    return {
      loginPopupTimer: this.$component.dataset.loginPopupTimer ? this.$component.dataset.loginPopupTimer : 5000,
      loginFloatingIconTimer: this.$component.dataset.loginFloatingIconTimer ? this.$component.dataset.loginFloatingIconTimer : 5000,

      loginTogglerButton: this.$component.querySelector(this.SELECTORS.loginTogglerButton),
      textContainer: this.$component.querySelector(this.SELECTORS.textContainer),
      textCloseBtn: this.$component.querySelector(this.SELECTORS.textCloseBtn),
      loginPopup: this.$component.querySelector(this.SELECTORS.loginPopup),
      accountIconLoginPopup: this.$component.querySelector(this.SELECTORS.accountIconLoginPopup),
      loginPopupBackdrop: this.$component.querySelector(this.SELECTORS.loginPopupBackdrop),
      popupCloseBtn: this.$component.querySelector(this.SELECTORS.popupCloseBtn),
      pwdRecoveryBtn: this.$component.querySelector(this.SELECTORS.pwdRecoveryBtn),
      loginForm: this.$component.querySelector(this.SELECTORS.loginForm),
      showLoginBtn: this.$component.querySelector(this.SELECTORS.showLoginBtn),

      //my account icons
      accountIconLoginPopups: document.querySelectorAll(this.SELECTORS.accountIconLoginPopup),

      recoveryPasswordContainer: this.$component.querySelector(this.SELECTORS.recoveryPasswordContainer),
      recoveryPasswordForm: this.$component.querySelector(this.SELECTORS.recoveryPasswordForm),
      recoveryPasswordFormButton: this.$component.querySelector(this.SELECTORS.recoveryPasswordFormButton),
      recoveryPasswordFormInput: this.$component.querySelector(this.SELECTORS.recoveryPasswordFormInput),
      responseSuccessWrapper: this.$component.querySelector(this.SELECTORS.responseSuccessWrapper),
      recoveryPasswordFormWrapper: this.$component.querySelector(this.SELECTORS.recoveryPasswordFormWrapper),
      loginPopupSpeechBubbleCta: this.$component.querySelector(this.SELECTORS.loginPopupSpeechBubbleCta),
    }
  }

  handlePopupTextClose() {
    //the cookie already exists, hide text section
    if (Cookies.get(this.COOKIE_NAME.popupTextClose)) {
      this.dom.textContainer.classList.add(this.CLASSES.hidden);
    }

    if (this.dom.textCloseBtn) {
      this.dom.textCloseBtn.addEventListener("click", event => {
        //set cookie
        Cookies.set(this.COOKIE_NAME.popupTextClose);
        //hide text container
        this.dom.textContainer.classList.add(this.CLASSES.hidden);
      });
    }
  }

  handleLoginTogglerClick() {
    if(this.dom.loginPopupSpeechBubbleCta) {
      this.dom.loginPopupSpeechBubbleCta.addEventListener('click', () => {
        this.loginPopupOpen();
      });
    }
    if(this.dom.loginTogglerButton) {
      this.dom.loginTogglerButton.addEventListener("click", event => {
        this.loginPopupOpen();
      });
    }
  }

  handleMyAccountClick() {
    if (this.dom.accountIconLoginPopups) {
      this.dom.accountIconLoginPopups.forEach(icon => {
        icon.addEventListener("click", event => {
          this.loginPopupOpen();
        });
      });
    }
  }

  loginPopupOpen() {
    this.dom.loginPopup.classList.add("show");
    this.dom.loginPopupBackdrop.classList.remove(this.CLASSES.hidden);
    //hide text and button
    this.dom.textContainer?this.dom.textContainer.classList.add("hidden") : "";
    // stop textContainer setTimeout
    if (this.textContainerTimerId) {
      clearTimeout(this.textContainerTimerId);
    }
    this.dom.loginTogglerButton?this.dom.loginTogglerButton.classList.add(this.CLASSES.hidden) : "";
    this.$emit(this.$customEvents.POPUP_EVENTS.pauseTimer);
  }

  loginPopupClose() {
    this.dom.popupCloseBtn.addEventListener("click", event => {
      Cookies.set(this.COOKIE_NAME.popupLoginClose);
      this.dom.loginPopup.classList.remove("show");
      this.dom.loginPopupBackdrop.classList.add(this.CLASSES.hidden);
      this.dom.loginTogglerButton ? this.dom.loginTogglerButton.classList.remove(this.CLASSES.hidden) : '';
      if (!Cookies.get(this.COOKIE_NAME.popupTextClose)) {
        this.dom.textContainer ? this.dom.textContainer.classList.remove(this.CLASSES.hidden) : '';
      }
      //fire login close events
      this.$emit(this.$customEvents.POPUP_EVENTS.resumeTimer);
    });
  }

  // pwd recovery

  // PASSWORD RESET FORM HANDLING //
  toggleResetPasswordForm() {
    this.dom.recoveryPasswordContainer.classList.toggle(this.CLASSES.hidden);
    this.dom.loginForm.classList.toggle(this.CLASSES.hidden);
  }

  // hide/show pwdRecovery and pwdRecovery success msg
  togglePwdRecoverySuccess() {
    const dom = this.readDOM();
    this.dom.responseSuccessWrapper.classList.toggle(this.CLASSES.hidden);
    this.dom.recoveryPasswordFormWrapper.classList.toggle(this.CLASSES.hidden);
  }

  // Should be a call to controller to reset the form, ok for now
  cleanPwdRecoveryForm() {
    if (this.dom.recoveryPasswordFormWrapper) {
      const form = this.dom.recoveryPasswordFormWrapper;

      if (form) {

        const input = form.querySelector(this.SELECTORS.recoveryPasswordInput);
        if (input) {
          input.value = '';
          input.parentElement.classList.remove('error');

          const formInput = form.querySelector('.form-input');
          const error = formInput?.querySelector('span.--msg-error');
          if (error) {
            formInput.removeChild(error);
          }
        }
        const btn = form.querySelector(this.SELECTORS.recoveryPasswordBtn);
        if (btn) {
          btn.classList.remove(this.CLASSES.loading);
        }

      }
    }
  }

  handlePwdRecovery() {
    if(this.dom.pwdRecoveryBtn) {
      this.dom.pwdRecoveryBtn.addEventListener("click", () => this.toggleResetPasswordForm());
    }
    if(this.dom.showLoginBtn) {
      this.dom.showLoginBtn.addEventListener("click", () => this.toggleResetPasswordForm());
    }
    if(this.dom.recoveryPasswordForm) {
      this.dom.recoveryPasswordForm.addEventListener("submit", (event) => this.recoverPassword(event));
    }
  }

  recoverPassword(event) {
    const ctx = this;

    event.preventDefault();
    const url = this.dom.recoveryPasswordForm.getAttribute('action');
    const form = new URLSearchParams(new FormData(this.dom.recoveryPasswordForm));

    ctx.manageSendFromLayer(true, true);
    ctx.readDOM().recoveryPasswordFormButton.classList.add(this.CLASSES.loading);

    fetch(url, {
      method: 'POST',
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: form
    })
      .then(res => {
        if (res.ok) {
          res.text().then(text => {
            const response = new DOMParser().parseFromString(text, 'text/html');
            // put response in page
            const responseSuccess = response.querySelector(ctx.SELECTORS.responseSuccess);
            const responseFail = response.querySelector(ctx.SELECTORS.responseFail);
            if (responseSuccess != null) {
              // toggle recovery form
              ctx.togglePwdRecoverySuccess();
              // replace html
              ctx.readDOM().responseSuccessWrapper.innerHTML = responseSuccess.innerHTML;
              // close layer on timer
              setTimeout(function () {
                ctx.manageSendFromLayer(false, false);
                ctx.toggleResetPasswordForm();
                ctx.togglePwdRecoverySuccess();
                ctx.cleanPwdRecoveryForm();
              }, 3000);
            }
            if (responseFail != null) {
              // replace html input
              const layerInput = ctx.readDOM().recoveryPasswordForm.querySelector('.form-input');
              ctx.readDOM().recoveryPasswordForm.replaceChild(responseFail, layerInput);
              ctx.readDOM().recoveryPasswordFormInput.value = '';
              // stop loading
              ctx.readDOM().recoveryPasswordFormButton.classList.remove(this.CLASSES.loading);
              // open layer, remove forced
              ctx.manageSendFromLayer(false, true);
            }
          })
        } else {
          console.error(res);
          ctx.manageSendFromLayer(false, true);
          ctx.readDOM().recoveryPasswordFormButton.classList.remove(this.CLASSES.loading);
        }
      })
      .catch(error => this.warn(error));
  }

  manageSendFromLayer(forceShow = false, focus = false) {
    forceShow ? this.$component.classList.add('--sending') : this.$component.classList.remove('--sending');

    if (this.readDOM().recoveryPasswordFormInput) {
      focus ? this.readDOM().recoveryPasswordFormInput.focus() : this.readDOM().recoveryPasswordFormInput.blur();
    }
  }

  // TIMERS LOGIC
  incrementTimer() {
    this.counter++;
    const maxTime = parseInt(this.dom.loginPopupTimer, 10) / 1000;
    if (this.counter >= maxTime) {
      this.pauseTimer();
      this.loginPopupOpen();
    }
  }

  startTimer() {
    this.timerId = setInterval(this.incrementTimer.bind(this), 1000);
  }

  pauseTimer() {
    if (this.timerId) clearInterval(this.timerId);
    if (this.timeoutId) clearTimeout(this.timeoutId);
  }

  resumeTimer() {
    this.timerId = setInterval(this.incrementTimer.bind(this), 1000);
  }

  timerEvents() {
    this.$on(this.$customEvents.POPUP_EVENTS.pauseTimer, () => {
      this.pauseTimer();
    });
    this.$on(this.$customEvents.POPUP_EVENTS.resumeTimer, () => {
      if (!Cookies.get(this.COOKIE_NAME.popupLoginClose)) {
        this.timeoutId = setTimeout(this.resumeTimer.bind(this), 2000);
      }
    });
  }

  timersLogic() {
    // Check if there's the login error query parameter
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const loginError = urlParams.get('loginerror');
    if (`${loginError}` === 'true' && this.loginPopupActive !== "false") {
      this.loginPopupOpen();
    } else {
      if (!Cookies.get(this.COOKIE_NAME.popupLoginClose)) {
        // show login popup after timeout
        this.startTimer();
      } else {
        setTimeout(() => {
          if (this.dom.loginTogglerButton && !this.dom.loginPopup.classList.contains("show")) {
            this.dom.loginTogglerButton.classList.remove("hidden");
          }
        }, this.dom.loginPopupTimer);
        setTimeout(() => {
          if (!Cookies.get(this.COOKIE_NAME.popupTextClose) && this.dom.textContainer &&
              !this.dom.loginPopup.classList.contains("show")) {
            this.dom.textContainer.classList.remove("hidden");
          }
        }, this.dom.loginFloatingIconTimer);
      }
    }
  }

  bindEvents() {
    this.handleMyAccountClick();
    this.loginPopupClose();
    // pwd recovery
    this.handlePwdRecovery();

    if (this.loginPopupActive !== "false") {
      this.timersLogic()
      this.handlePopupTextClose();
      this.handleLoginTogglerClick();
    }
  }

  render() {
    this.dom = this.readDOM();
    setTimeout(() => {
    const embeddedMessagingConversationButton = document.getElementById('embeddedMessagingConversationButton')
    const isHidden = embeddedMessagingConversationButton
    ? getComputedStyle(embeddedMessagingConversationButton).display === 'none'
    : true;
    if (isHidden) {
      this.$component.style.bottom = '45px';
      }
    }, this.dom.loginFloatingIconTimer);

    this.bindEvents();
    this.timerEvents();
  }
}
